import {CloseOutlined} from "@ant-design/icons";
import {Modal} from "antd";
import React from "react";
import './PopmenuWelcomeModal.scss';
import MhmLogo from "../icons/MhmLogo";
import PopmenuLogoAlternate from "../icons/PopmenuLogoAlternate";
import { useRecoilState } from "recoil";
import { memberState } from "../../state/atoms";

interface PopmenuWelcomeModalProps {
  visible: boolean;
  onClose: () => void;
}

export default function PopmenuWelcomeModal({visible, onClose}: PopmenuWelcomeModalProps) {
  const [member] = useRecoilState(memberState);
  
  return <Modal className={"clean one popmenu-welcome"} open={visible} onCancel={onClose}>
    <div className={"modal-title"}>
      <span onClick={onClose}><CloseOutlined/></span>
    </div>
    <div className={'modal-body'}>
      <header>
        <div>
          <MhmLogo/>
          <div className={'separator'}></div>
          <PopmenuLogoAlternate/>
        </div>

        <div>
          <h1>Welcome!</h1>
        </div>
      </header>
      <section>
        <video src="https://timber.mhmcdn.com/site/marketing/homepage/dashboard/PopmenuDashboardExample.mp4" autoPlay loop muted playsInline/>
        <div>
          <span>To add your Popmenu data:</span>
          <ol>
            <li>Inside design editor, choose Import on the Text tab</li>
            <li>Select POS and there's your data!</li>
          </ol>
        </div>
      </section>

      <footer>
        <span>See full <a href="https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029518-setting-up-the-popmenu-integration" target="_blank" rel="noreferrer">Help Article</a></span>
        <div className={'separator'}></div>
        <span>Want a friendly tour? <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} target="_blank" rel="noreferrer">Book an Intro</a></span>
      </footer>
    </div>
  </Modal>
}
